{
  "m": {
    "f": "icons",
    "u": 1024,
    "z": 1020,
    "s": 59648,
    "h": "c15a8b1711b1258e171706cf929c61804d6d2c92f85b93bf7869b259cdd2d3e1"
  },
  "i": {
    "arrow-right": [1024, [[59648, "currentColor"]]],
    "arrow-turn-down-left": [1024, [[59649, "currentColor"]]],
    "arrow-up": [1024, [[59650, "currentColor"]]],
    "cast-filled": [1024, [[59651, "currentColor"]]],
    "cast": [1024, [[59652, "currentColor"]]],
    "check": [1024, [[59653, "currentColor"]]],
    "chevron-down": [1024, [[59654, "currentColor"]]],
    "chevron-left": [1024, [[59655, "currentColor"]]],
    "chevron-right": [1024, [[59656, "currentColor"]]],
    "circle-info": [1024, [[59657, "currentColor"]]],
    "close-fullscreen": [1024, [[59658, "currentColor"]]],
    "close": [1024, [[59659, "#fff"]]],
    "closed-captions": [1024, [[59660, "currentColor"]]],
    "disconnect": [1024, [[59661, "currentColor"]]],
    "document": [1024, [[59662, "currentColor"]]],
    "enter-pip": [1024, [[59663, "currentColor"]]],
    "exit-pip": [1024, [[59664, "currentColor"]]],
    "folder": [1024, [[59665, "currentColor"]]],
    "fullscreen": [1024, [[59666, "currentColor"]]],
    "home": [1024, [[59667, "currentColor"]]],
    "keyboard": [1024, [[59668, "currentColor"]]],
    "lock": [1024, [[59669, "currentColor"]]],
    "mic": [1024, [[59670, "currentColor"]]],
    "more": [1024, [[59671, "currentColor"]]],
    "movie": [1024, [[59672, "currentColor"]]],
    "pause": [1024, [[59673, "currentColor"]]],
    "pencil": [1024, [[59674, "currentColor"]]],
    "person-outline": [1024, [[59675, "currentColor"]]],
    "play": [1024, [[59676, "currentColor"]]],
    "plus": [1024, [[59677, "currentColor"]]],
    "remote": [1024, [[59678, "currentColor"]]],
    "retry": [1024, [[59679, "currentColor"]]],
    "search": [1024, [[59680, "currentColor"]]],
    "settings": [1024, [[59681, "currentColor"]]],
    "share": [1024, [[59682, "currentColor"]]],
    "sign-in": [1024, [[59683, "currentColor"]]],
    "sign-out": [1024, [[59684, "currentColor"]]],
    "skip-backward": [1024, [[59685, "currentColor"]]],
    "skip-forward": [1024, [[59686, "currentColor"]]],
    "sound-muted": [1024, [[59687, "currentColor"]]],
    "sound-on": [1024, [[59688, "currentColor"]]],
    "stop": [1024, [[59689, "currentColor"]]],
    "switch": [1024, [[59690, "currentColor"]]],
    "trash": [1024, [[59691, "currentColor"]]],
    "tv-filled": [1024, [[59692, "currentColor"]]],
    "tv-play": [1062, [[59693, "currentColor"]]],
    "tv": [1024, [[59694, "currentColor"]]]
  }
}
